import React, { useState, useEffect, useCallback } from "react";
import { Modal } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
import CommonButton from "../button";
import CommonDropDown from "../dropdown";
import CommonInput from "../input";
import { getCurrenciesAction } from "../../containers/login/action";
import {
  createWithdrawalCategoryAction,
  updateWithdrawalCategoryAction,
  getWithdrawalCategoryAction,
} from "../../containers/dashboard/action";
let currencyOptions = [];

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(() => ({
  modalPaper: {
    position: "absolute",
  },
  container: {
    width: "350px",
    backgroundColor: theme.colors.White,
    boxShadow: "0px 0px 10px #CFD9EA80",
    borderRadius: "15px",
    padding: "50px 60px",
    "& .block": {
      marginBottom: "15px",
      "& .label": { fontSize: "18px", marginBottom: "5px" },
      "& .value": {
        fontSize: "18px",
        fontFamily: theme.fontFamily.MARKPROBOLD,
      },
    },
    "& .textArea": {
      width: "94%",
      backgroundColor: theme.colors.Zumthor,
      color: theme.colors.Violet,
      fontSize: "18px",
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      borderColor: theme.colors.Zumthor,
      borderRadius: "5px",
      padding: "10px",
      "&:hover": {
        borderColor: theme.colors.DodgerBlue,
        outline: "none",
      },
      "&:focus-visible": {
        borderColor: theme.colors.DodgerBlue,
        outline: "none",
      },
    },
    "& .imageContainer": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "20px",
    },
    "& .approvalMsg": {
      color: theme.colors.Violet,
      fontSize: "24px",
      fontFamily: theme.fontFamily.MARKPROLIGHT,
      marginBottom: "40px",
    },
  },
}));

function WithdrawalLimitCategoryModal({ openModal, editId, onClose }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const getCurrenciesMethod = useCallback(
    (data) => dispatch(getCurrenciesAction(data)),
    [dispatch]
  );

  const createWithdrawalCategoryMethod = useCallback(
    (data) => dispatch(createWithdrawalCategoryAction(data)),
    [dispatch]
  );

  const updateWithdrawalCategoryMethod = useCallback(
    (data, limit_id) => dispatch(updateWithdrawalCategoryAction(data, limit_id)),
    [dispatch]
  );

  const getWithdrawalCategoryMethod = useCallback(
    (limit_id) => dispatch(getWithdrawalCategoryAction(limit_id)),
    [dispatch]
  );

  const [modalStyle] = useState(getModalStyle);

  const [limitDescription, setLimitDescription] = useState(null);
  const [limitName, setLimitName] = useState(null);
  const [limit, setLimit] = useState(10);

  const dashboardReducer = useSelector((state) => {
    return state.dashboardReducer;
  });

  const loginReducer = useSelector((state) => {
    return state.loginReducer;
  });

  useEffect(() => {
    if (editId) getWithdrawalCategoryMethod(editId);
  }, [editId, getWithdrawalCategoryMethod]);

  useEffect(() => {
    if (loginReducer?.currencyOptions?.length) {
      for (let i = 0; i < loginReducer?.currencyOptions.length; i++) {
        const each = loginReducer?.currencyOptions[i];
        if (currencyOptions.findIndex((rec) => rec.value === each.id) < 0)
          currencyOptions.push({ value: each.id, label: each.name });
      }
    }
  }, [loginReducer]);

  useEffect(() => {
    const { createWithdrawalCategorySuccess, updateWithdrawalCategorySuccess, withdrawalLimitCategoryInfo } =
      dashboardReducer;
    if (createWithdrawalCategorySuccess || updateWithdrawalCategorySuccess) {
      onClose();
      setLimit(10);
      setLimitName(null);
      setLimitDescription(null);
    }
    if (withdrawalLimitCategoryInfo && editId) {
      if (Number(withdrawalLimitCategoryInfo?.limit) >= 0) {
        setLimit(withdrawalLimitCategoryInfo.limit);
      }
      if (withdrawalLimitCategoryInfo.description && editId) {
        setLimitDescription(withdrawalLimitCategoryInfo.description)
      }
      if (withdrawalLimitCategoryInfo.name && editId) {
        setLimitName(withdrawalLimitCategoryInfo.name);
      }
    }
  }, [dashboardReducer, onClose, editId]);


  useEffect(() => {
    if (
      dashboardReducer?.createWithdrawalCategoryError?.length ||
      dashboardReducer?.updateWithdrawalCategoryError?.length
    ) {
      const ele = document.getElementsByClassName("error-container");
      if (ele && ele.length) ele[0].scrollIntoView(false);
    }
  }, [dashboardReducer]);

  return (
    <Modal
      open={openModal}
      onClose={() => {
        onClose();
        setLimit(10);
        setLimitDescription(null);
        setLimitName(null);
      }}
    >
      <div style={modalStyle} className={classes.modalPaper}>
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (editId)
              updateWithdrawalCategoryMethod(
                {
                  name: limitName,
                  description: limitDescription,
                  limit: limit,
                },
                editId
              );
            else
              createWithdrawalCategoryMethod({
                name: limitName,
                description: limitDescription,
                limit: limit,
              });
            
            onClose();
          }}
        >
          <div className={classes.container}>
            {dashboardReducer?.createWithdrawalCategoryError?.length ? (
              <div className={"error-container"}>
                {dashboardReducer.createWithdrawalCategoryError.map((each, index) => (
                  <div key={index}>{each}</div>
                ))}
              </div>
            ) : dashboardReducer?.updateWithdrawalCategoryError?.length ? (
              <div className={"error-container"}>
                {dashboardReducer.updateWithdrawalCategoryError.map((each, index) => (
                  <div key={index}>{each}</div>
                ))}
              </div>
            ) : null}

            <div className="block">
              <div className="label">Name</div>
              <div className="value">
                <CommonInput
                  placeholder={`Enter The Limit Name`}
                  type="text"
                  value={limitName}
                  onChange={(e) => {
                    setLimitName(e.target.value);
                  }}
                />
              </div>
            </div>

            <div className="block">
              <div className="label">Limit</div>
              <div className="value">
                <CommonInput
                  placeholder={`Enter Limit`}
                  type="number"
                  value={limit}
                  allowDecimal={2}
                  onlyPositive={true}
                  // min={10}
                  max={100}
                  onChange={(e) => {
                    setLimit(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="block">
              <div className="label">Description</div>
              <div className="value">
                <CommonInput
                  placeholder={`Enter The Description`}
                  type="text"
                  value={limitDescription}
                  onChange={(e) => {
                    setLimitDescription(e.target.value);
                  }}
                />
              </div>
            </div>

            <div>
              <CommonButton
                type="submit"
                text={editId ? "Update" : "Create"}
                stylevariant="secondary1"
                disabled={
                  !(limit >= 10) ||
                  !limitName ||
                  !limitDescription ||
                  (limitName &&
                    limitDescription &&
                    limitName === limitDescription)
                }
                style={{ marginTop: "20px", marginBottom: "20px" }}
              />

              <CommonButton
                type="button"
                text={"Cancel"}
                stylevariant="secondary2"
                onClick={() => {
                  setLimit(10);
                  setLimitDescription(null);
                  setLimitName(null);
                  onClose();
                }}
              />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default WithdrawalLimitCategoryModal;
